import { useSelector } from 'react-redux'

const useCheckPermission = () => {
  const { adminPermissions , adminDetails } = useSelector(state => state.admins)
  const isHidden = ({ module }) => {
    if (adminDetails?.adminRoleId === 1) {
      return false;
    }
    return !(adminPermissions && (Object.keys(adminPermissions).includes(module.key) && adminPermissions[module.key].includes(module.value)))
  }

  const isSuperAdmin = () => {
  return   adminDetails?.adminRoleId === 1
  }
  return { isHidden , isSuperAdmin}
}
export default useCheckPermission
